export default __webpack_public_path__ + "static/media/step_3.e478965a.png";